// extracted by mini-css-extract-plugin
export default {"QualifiedSwitch":"styles_QualifiedSwitch__Wtkpl","option":"styles_option__Snljv","active":"styles_active__AzCfQ","count":"styles_count__UCgop"};